import { render, staticRenderFns } from "./lkuPorder.1.vue?vue&type=template&id=508b7e5e"
import script from "./lkuPorder.1.vue?vue&type=script&lang=js"
export * from "./lkuPorder.1.vue?vue&type=script&lang=js"
import style0 from "./lkuPorder.1.vue?vue&type=style&index=0&id=508b7e5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports